import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams';
import { Id } from 'types/Id';

import { parseRelationInputForBE, parseRelationsForFE, parseRelationForFE, parseRelationTypeForFE } from './assetRelations.parsers';
import { AssetRelationInput } from './assetRelations.types';

const endpoint = 'api/v1/asset_relations/';
const categoryEndpoint = 'api/v1/asset_relation_categories/';
const typeEndpoint = 'api/v1/asset_relation_types/';
const assetEndpoint = 'api/v1/assets/';

const languageConfig = (language?: string) =>
  language
    ? {
        headers: { 'Accept-Language': language },
      }
    : undefined;

const assetRelationsApi = {
  getCategories: async (language?: string) => {
    const { data } = await axios.get(categoryEndpoint, languageConfig(language));
    return data;
  },
  getTypes: async (category?: string, language?: string) => {
    const { data } = await axios.get(createUrlWithParams(typeEndpoint, category ? { category } : {}), languageConfig(language));
    return data.map(parseRelationTypeForFE);
  },
  getAll: async (params?: Record<string, any>, language?: string) => {
    const { data } = await axios.get(createUrlWithParams(endpoint, params || {}), languageConfig(language));
    return { ...data, results: parseRelationsForFE(data.results || []) };
  },
  getForAsset: async (assetId: Id, language?: string) => {
    const { data } = await axios.get(`${assetEndpoint}${assetId}/relations/`, languageConfig(language));
    return { ...data, results: (data.results || []).map(parseRelationForFE) };
  },
  create: async (input: AssetRelationInput) => {
    const { data } = await axios.post(endpoint, parseRelationInputForBE(input));
    return parseRelationForFE(data);
  },
  createForAsset: async ({ assetId, input }: { assetId: Id; input: AssetRelationInput }) => {
    const { data } = await axios.post(`${assetEndpoint}${assetId}/relations/`, parseRelationInputForBE(input));
    return parseRelationForFE(data);
  },
  update: async ({ id, input }: { id: Id; input: AssetRelationInput }) => {
    const { data } = await axios.patch(`${endpoint}${id}/`, parseRelationInputForBE(input));
    return parseRelationForFE(data);
  },
  remove: async (id: Id) => axios.delete(`${endpoint}${id}/`),
};

export default assetRelationsApi;
